export default "__VITE_PUBLIC_ASSET__1424f564__"